var exports = {
  "kL": "xf61da738--008a5a--container",
  "Kk": "xf61da738--008a5a--icon",
  "UU": "xf61da738--008a5a--name",
};

module.exports = exports;
